export default "__VITE_ASSET__CNF1LMN4__"